/**
 * Regra de acesso multi-cliente, portada da versão em produção
 * (`laborder/index.tsx:283-329`).
 *
 * Quando o usuário entra sem cliente selecionado (acesso do tipo "conta",
 * `codCliente === ''`), ele enxerga OS de vários clientes. Abrir uma OS que
 * pertence a um cliente específico nesse estado é perigoso: o formulário salva
 * usando o `codCliente` da querystring, que estaria vazio — a OS seria gravada
 * no cliente errado.
 */

/**
 * #TODO (18/08/2026): VERIFICAR SE ESTA REGRA AINDA FAZ SENTIDO.
 *
 * A listagem passou a exigir uma propriedade selecionada, e propriedade implica
 * cliente — na prática não se chega mais à lista com `codCliente` vazio, então o
 * ramo que bloqueia provavelmente nunca é alcançado. Mantida por segurança: é
 * barata, cobre um caminho de acesso "conta" que possa ter sobrado, e o custo de
 * remover cedo demais seria gravar OS no cliente errado.
 *
 * Ao confirmar que o acesso multi-cliente não alcança mais esta tela, remover
 * esta função, `mensagemClienteDivergente` e o guard `bloqueadoPorCliente` do
 * submódulo.
 *
 * `true` quando a OS pode ser aberta para editar/clonar no contexto atual.
 */
export function podeAbrirOs(cod_cliente_da_os: number | null | undefined, cod_cliente_atual: string | number): boolean {
    // Com um cliente selecionado a lista já vem filtrada por ele — nada a barrar.
    if (String(cod_cliente_atual ?? '') !== '') return true

    // Sem cliente selecionado, só OS que também não pertencem a um cliente.
    return cod_cliente_da_os === null || cod_cliente_da_os === undefined
}

/** Mensagem exibida quando a OS pertence a outro cliente. */
export function mensagemClienteDivergente(acao: 'editar' | 'clonar', nome_cliente?: string): string {
    const cliente = (nome_cliente ?? '').trim()

    return cliente !== ''
        ? `Para ${acao} selecione o cliente correspondente: ${cliente}`
        : `Para ${acao} selecione o cliente correspondente a esta OS.`
}

/**
 * `true` quando a listagem pode conter OS de VÁRIOS clientes — ou seja, quando
 * não há cliente selecionado no filtro global.
 *
 * Só nesse caso a linha precisa dizer de quem é a propriedade; com um cliente
 * selecionado a informação seria a mesma em todas as linhas. Mesma condição que
 * a versão em produção usa para esconder a coluna "Cliente"
 * (`laborder/useLogic.tsx:73`).
 */
export function exibirClienteNaLinha(cod_cliente_atual: string | number | null | undefined): boolean {
    return String(cod_cliente_atual ?? '') === ''
}

/**
 * Motivo pelo qual gravar não é permitido no contexto atual, ou `undefined`
 * quando é.
 *
 * Sem cliente no filtro global a listagem mistura clientes e o formulário salva
 * com o `codCliente` da querystring, que estaria vazio — a OS iria para o cliente
 * errado. Ver/imprimir seguem liberados; o que trava é escrever.
 */
export function motivoSemClienteGlobal(cod_cliente_atual: string | number | null | undefined): string | undefined {
    return String(cod_cliente_atual ?? '') === ''
        ? 'Selecione um cliente no menu superior para editar esta O.S.'
        : undefined
}
